import React, { useState } from "react";
import "./PublicacionCard.css";
import { DeletePublicidad } from "../../Backend/ApiCalls";

// ✅ Lightbox + Zoom (pinch to zoom)
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import { resolveSponsorImage } from '../../utils/sponsorMedia';

export default function PublicacionCard({ item, isAdmin, onEdit, onDelete, highlighted = false }) {
  // ✅ Lightbox state
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const openLightbox = (index) => {
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  // Slides del lightbox (galería)
  const slides =
    item.gallery && item.gallery.length > 0
      ? item.gallery.map((src) => ({ src: resolveSponsorImage(src) }))
      : [];

  // ELIMINAR PUBLICACIÓN
  const handleDelete = async () => {
    await DeletePublicidad(item.id);
    onDelete(item.id); // avisar a la lista que refresque
  };

  return (
    <article
      id={`publication-${item.id}`}
      className={`publicacion-card${highlighted ? ' linked-publication-highlight' : ''}`}
    >
      {/* Logo */}
      {item.companyLogo && (
        <img src={resolveSponsorImage(item.companyLogo)} alt={`Logo de ${item.title}`} className="publicacion-logo" />
      )}

      {/* Título */}
      <h2 className="publicacion-titulo">{item.title}</h2>

      {/* Descripción */}
      <p className="publicacion-descripcion">{item.description}</p>

      {/* Link */}
      {item.link && (
        <a
          href={item.link}
          target="_blank"
          rel="noopener noreferrer"
          className="publicacion-link button-default"
        >
          Ver más
        </a>
      )}

      {/* Galería (click -> lightbox + zoom) */}
      {item.gallery && item.gallery.length > 0 && (
        <div className="publicacion-galeria">
          {item.gallery.map((img, index) => (
            <img
              key={index}
              src={resolveSponsorImage(img)}
              alt={`gallery-${index}`}
              className="galeria-img zoomable-img"
              loading="lazy"
              onClick={() => openLightbox(index)}
            />
          ))}
        </div>
      )}

      {/* ✅ Lightbox (1 instancia por card) */}
      <Lightbox
        className="fp-lightbox"
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        slides={slides}
        index={lightboxIndex}
        on={{ view: ({ index }) => setLightboxIndex(index) }}
        plugins={[Zoom]}
        carousel={{ imageFit: "contain" }}
        controller={{ closeOnBackdropClick: true, closeOnPullDown: true }}
        zoom={{ scrollToZoom: true, pinchZoomV4: true }}
      />

      {/* Botones admin */}
      {isAdmin && (
        <div className="admin-btns">
          <button className="button-default" onClick={() => onEdit(item)}>
            Editar
          </button>

          <button className="delete-button" onClick={handleDelete}>
            Eliminar
          </button>
        </div>
      )}
    </article>
  );
}
